import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatTabChangeEvent as MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';


export interface ClientTab {
  label: string;
  path: string;
  content: string | SafeResourceUrl;
  contentType: 'markdown' | 'iframe';
}

const TABS_CONFIG: ClientTab[] = [
  { label: 'ImgSigner', path: '/clients/imgsigner', contentType: 'markdown', content: '/assets/docs/client/imgsigner.md' },
  { label: 'CLI', path: '/clients/cli', contentType: 'markdown', content: '/assets/docs/client/cli.md' },
  { label: 'REST', path: '/clients/rest', contentType: 'iframe', content: '/libs/rest/api/index.html' },
  { label: '.NET', path: '/clients/dotnet', contentType: 'iframe', content: '/libs/client-csharp/index.html' },
  { label: 'Node.js', path: '/clients/nodejs', contentType: 'iframe', content: '/libs/client-node/index.html' },
  { label: 'Python', path: '/clients/python', contentType: 'iframe', content: '/libs/client-python/index.html' }
];

@Component({
  selector: 'app-clients',
  standalone: false,
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.css']
})
export class ClientsComponent implements OnInit {
  public selectedIndex: number = 0;
  public tabs: ClientTab[] = [];
  public loading: boolean = true;

  constructor(private router: Router, private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.tabs = TABS_CONFIG.map(tab => {
      if (tab.contentType === 'iframe') {
        return { ...tab, content: this.bypassSecurity(tab.content as string) };
      }
      return tab;
    });

    const currentPath = this.router.url;
    const initialIndex = this.tabs.findIndex(tab => tab.path === currentPath);

    this.selectedIndex = (initialIndex > -1) ? initialIndex : 0;

    this.loading = false;
  }

  bypassSecurity(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  selectedTabChange(event: MatTabChangeEvent): void {
    const selectedTab = this.tabs[event.index];
    if (selectedTab) {
      this.router.navigate([selectedTab.path]);
    }
  }
}
